import { render, staticRenderFns } from "./priceDialog.vue?vue&type=template&id=65043f63&scoped=true&"
import script from "./priceDialog.vue?vue&type=script&lang=js&"
export * from "./priceDialog.vue?vue&type=script&lang=js&"
import style0 from "./priceDialog.vue?vue&type=style&index=0&id=65043f63&lang=scss&scoped=true&"
import style1 from "./priceDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65043f63",
  null
  
)

export default component.exports